import type { AtmosphereType } from "./types/AtmosphereType";
import type { FinanceCarItemType } from "../../../../common-deprecated/features/apheleia/utils/types/Finance";
import { appendMonthlyPrice } from "../../shared-logic/utils/priceUtils";

export const appendAtmospheresWithMonthlyPrice = (
    atmospheres: AtmosphereType[],
    finance: Record<string, FinanceCarItemType>,
): AtmosphereType[] => {
    return atmospheres.reduce((acc: AtmosphereType[], atmos) => {
        if (finance[atmos.car.id]) {
            const { financeInfo } = finance[atmos.car.id];
            atmos = {
                ...atmos,
                price: appendMonthlyPrice(atmos.price, financeInfo),
            };
        }
        return [...acc, atmos];
    }, []);
};
